import React, { useEffect, useState } from "react";
import Modal from "./Modal"; // Import the Modal component
import './Gallery.css'; // Import the CSS file for styling

function Gallery() {
  const [media, setMedia] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const accessToken = process.env.REACT_APP_INSTAGRAM_TOKEN;

  useEffect(() => {
    const fetchInstagramMedia = async () => {
      try {
        const response = await fetch(`https://graph.instagram.com/me/media?fields=id,caption,media_type,media_url,thumbnail_url&access_token=${accessToken}`);
        const data = await response.json();
        
        if (data && data.data) {
          setMedia(data.data); // Set the media data to state
        } else {
          console.error("No media found or error in response:", data);
        }
      } catch (error) {
        console.error("Error fetching Instagram media:", error);
      }
    };

    fetchInstagramMedia();
  }, [accessToken]);

  const openModal = (imageUrl, caption) => {
    setSelectedImage({ imageUrl, caption });
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedImage(null);
  };

  return (
    <div className="gallery-section">
      <h2>Gallery</h2>
      <div className="gallery-grid">
        {media.map((item, index) => (
          <div key={index} className="gallery-item" onClick={() => item.media_type === "IMAGE" && openModal(item.media_url, item.caption)}>
            {item.media_type === "IMAGE" ? (
              <img src={item.media_url} alt={item.caption} className="gallery-image" />
            ) : item.media_type === "VIDEO" ? (
              <video controls className="gallery-video">
                <source src={item.media_url} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            ) : null}
          </div>
        ))}
      </div>

      {/* Modal for full-screen image */}
      <Modal 
        isOpen={isModalOpen} 
        onClose={closeModal} 
        imageUrl={selectedImage?.imageUrl} 
        caption={selectedImage?.caption} 
      />
    </div>
  );
}

export default Gallery;
